module.exports = __webpack_public_path__ + "img/theme8.47a4a0b5.png";